export default function CustomQuestions() {
  return (
    <div className="screen container">
      <h1>P6: Custom Questions</h1>
      <p style={{ color: 'var(--color-text-secondary)', marginTop: '8px' }}>
        Manage custom daily log questions for a client.
      </p>
      <div className="card" style={{ marginTop: '24px', textAlign: 'center', color: 'var(--color-text-muted)' }}>
        Coming soon — this screen will be built in Phase 2.
      </div>
    </div>
  );
}
